import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IHocLaiThiLaiRequest } from "../../../model/request/hoc-lai-thi-lai/IHocLaiThiLaiRequest";
import { IHocLaiThiLaiViewModel } from "../../../model/response/hoc-lai-thi-lai/IHocLaiThiLaiViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHocLaiThiLaiActionsObj = {
    LOAD_START: {} as IHocLaiThiLaiRequest,
    LOAD_SUCCESS: {} as IHocLaiThiLaiViewModel[],
    LOAD_ERROR: "",

    CHANGE_FOCUSED_TAB_CHANGE: {} as "hoc-lai" | "thi-lai" | "tat-ca",

    CHANGE_TRANG_THAI_HOC: {} as number[],
    CHANGE_NAM_HOC: {} as string,
    CHANGE_HOC_KY: {} as number,
    CHANGE_FOCUSED_VALUE_LOP: {} as ITreeviewLopFocusedValue,
}

export const eHocLaiThiLaiActionIds = generateActionTypeIds(eHocLaiThiLaiActionsObj, "HOC_LAI_THI_LAI");
export type IHocLaiThiLaiActionTypes = IGenericActionType<typeof eHocLaiThiLaiActionsObj, "HOC_LAI_THI_LAI">;

